import { NgModule } from "@angular/core";
import { InformationPanelItemComponent } from "./information-panel-item.component";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { SharedModule } from "src/app/shared/shared.module";

@NgModule({
  imports: [CommonModule, SharedModule, TranslateModule],
  exports: [InformationPanelItemComponent],
  declarations: [InformationPanelItemComponent],
})
export class InformationPanelItemModule {}
